<template>
  <section
    ref="top"
    class="business-list"
  >
    <div class="business-list__row">
      <div class="business-list__column business-list__column--left">
        <div class="business-list__header">
          <h2
            v-if="!businessRequestParams.keyword && businesses.length"
            class="business-list__heading business-list__heading--h2"
          >
            Businesses
          </h2>

          <h2
            v-else-if="
              businessRequestParams.keyword && businesses.length && !loading
            "
            class="business-list__heading business-list__heading--h2"
          >
            Results for "{{ businessRequestParams.keyword }}"
            <button
              class="business-list__clear"
              @click="handleKeywordRemove"
            >
              <span class="hidden-text">Remove search query</span>
              <img
                src="/img/icon/clear.svg"
                alt="Remove search query"
                class="business-list__icon-clear"
              >
            </button>
          </h2>
          <h2
            v-else-if="!loading"
            class="business-list__heading business-list__heading--h2"
          >
            No results found
          </h2>

          <section class="d-flex location-info-section">
            <div
              v-show="checkCookieByName('postalCode')"
              class="heading"
            >
              Your Postal Code: {{ checkCookieByName('postalCode') }}
            </div>
            <div
              v-show="checkCookieByName('currentLocation') && locationEnable && !checkCookieByName('setPostalCode')"
              class="heading"
            >
              Your current location enabled
            </div>
            <small
              v-show="!checkCookieByName('postalCode') && checkCookieByName('currentLocation')"
              class="sub-heading"
              @click="setCustomPostalCode"
            >Set Postal Code?</small>
            <small
              v-show="checkCookieByName('postalCode')"
              class="sub-heading"
              @click="setCustomPostalCode"
            >Set different Postal Code?</small>
            <br>
            <small
              v-show="!locationEnable || (locationEnable && checkCookieByName('setPostalCode'))"
              class="sub-heading"
              @click="getCurrentLocation"
            >Use Current Location?</small>
          </section>

          <div class="business-list__dropdowns">
            <v-select
              v-show="isProximity"
              ref="select"
              v-model="businessRequestParams.proximity"
              class="business-list__dropdown business-list__dropdown-proximity"
              label="proximity"
              placeholder="Proximity"
              :options="proximityOptions"
              :reduce="(option) => option.value"
              :value="null"
              :searchable="false"
              @input="handleFilterChange('proximity')"
              @search:focus="opened"
            />
            <div
              v-show="!isProximity"
              class="postal-code-block"
            >
              <input
                id="postal-code-input"
                v-model="postalCode"
                type="text"
                placeholder="Postal Code"
              >
              <button
                id="postal-code-clear"
                @click="verifyPostalCode"
              >
                Set
              </button>
            </div>

            <v-select
              ref="select"
              v-model="businessRequestParams.city"
              class="business-list__dropdown business-list__dropdown-city"
              label="name"
              placeholder="All Cities"
              :options="cityOptions"
              :searchable="true"
              :clear-search-on-select="true"
              @input="handleFilterChange('city')"
              @search:focus="opened"
            />

            <v-select
              ref="select"
              v-model="sortSettings"
              class="business-list__dropdown business-list__dropdown-sort"
              label="name"
              placeholder="Sort By"
              :options="sortOptions"
              :reduce="(option) => option.value"
              :value="null"
              :searchable="false"
              :clearable="false"
              :clear-search-on-select="false"
              @input="handleSortChange"
              @search:focus="opened"
            />
            <v-select
              ref="select"
              v-model="businessRequestParams.filter"
              class="business-list__dropdown business-list__dropdown-category"
              label="name"
              placeholder="All Categories"
              :options="categories"
              :reduce="(category) => category.slug"
              :selectable="(category) => !category.disabled"
              :searchable="false"
              :clear-search-on-select="false"
              @input="handleFilterChange"
              @search:focus="opened"
            >
              <template #option="{ option }">
                <span
                  :class="getOptionClass(option)"
                >
                  {{ option.name }}
                </span>
              </template>
            </v-select>
          </div>
          <Select2
            :options="tags"
            :model-value="businessRequestParams.tags"
            class="business-list__dropdown business-list__dropdown-tags"
            :placeholder="'Tags'"
            :settings="{ multiple: true }"
            @tagsSelected="handleTagChange"
          />
        </div>

        <div
          v-if="!businesses.length && !loading"
          class="business-list__empty"
        >
          <p class="business-list__paragraph">
            <strong>Sorry, no businesses were found. Here are some tips to improve
              your search:</strong>
          </p>
          <ul class="business-list__list">
            <li>Remove your category selection</li>
            <li>Choose a less specific search keyword</li>
            <li>
              <a href="/contact"><strong>Contact us</strong></a> to have your
              business listed
            </li>
          </ul>
        </div>

        <BusinessListCard
          v-for="business in businesses"
          :key="business.id"
          :ref="business.id"
          :business="business"
          :active-business="activeBusiness"
          :keyword="businessRequestParams.keyword"
        />

        <Pagination
          v-if="pagination.pageCount > 0 && businesses.length"
          :pagination="pagination"
          @updatePagination="updatePagination"
        />
      </div>
      <div class="business-list__column business-list__column--right">
        <div
          ref="stickyElement"
          class="google-map"
        >
          <GoogleMap
            style="width: 100%; height: 600px"
            :businesses="
              businesses.filter((business) => business.lat && business.lng
                && business.lat != 0 && business.lng != 0
                && business.address_1 &&
                business.city &&
                business.state_province)
            "
            @updateActiveBusiness="updateActiveBusiness"
          />

          <a
            href="https://frakxion.com/credo/"
            target="_blank"
          >
            <img
              id="main_page_ads"
              src="/img/ads/business-page-right.jpg?v4"
              alt="business_right_bar"
              style="margin-top: 0.5rem;width: 100%;"
            >
          </a>

          <a
            href="https://frakxion.com/credo/"
            target="_blank"
          >
            <img
              id="main_page_ads_mobile"
              src="/img/ads/business-page-right.jpg?v4"
              alt="business_right_bar_mobile"
              style="margin-top: 0.5rem;width: 100%;"
            >
          </a>
        </div>
      </div>
    </div>
    <Cookie ref="cookie" />
  </section>
</template>
<script>
import BusinessListCard from './BusinessListCard.vue';
import Select2 from './Select2';
import Pagination from './Pagination.vue';
import GoogleMap from './GoogleMap.vue';
import Cookie from './Cookie.vue';
import '../../../css/fontawsome.min.css';

import Stickyfill from 'stickyfilljs';

export default {
  components: {
    BusinessListCard,
    GoogleMap,
    Pagination,
    Cookie,
      Select2
  },
  props: {
    apiRoutes: { required: true, type: Object },
  },

    data() {
    return {
        loading: true,
        isMobile: true,
        postalCode: '',
        isProximity: false,
        locationEnable: false,
        useCurrentLocation: false,
        pageUrl: window.location.href.split('?')[0],
        queryString: '',
        address: {
            subdirectories: '',
            params: {},
        },
        categories: [],
        businesses: [],
        sortSettings: null,
        sortOptions: [
            {value: 'name.ASC', name: 'A-Z'},
            {value: 'name.DESC', name: 'Z-A'},
            {value: 'created_at.DESC', name: 'Recently Added'},
        ],
        cityOptions: [],
        proximityOptions: [
            {value: '1', proximity: '1km'},
            {value: '5', proximity: '5km'},
            {value: '10', proximity: '10km'},
            {value: '25', proximity: '25km'},
            {value: '50', proximity: '50km'},
            {value: '100', proximity: '100km'},
            {value: '250', proximity: '250km'},
            {value: 'unlimited', proximity: 'Unlimited'},
        ],
        pagination: {
            page: 1,
            pageCount: 0,
            resultCount: 0,
            from: 0,
            to: 0,
        },
        categoryRequestParams: {
            order_by: 'DESC',
            sort_by: 'created_at',
            page: 1,
            limit: 100,
        },
        businessRequestParams: {
            order_by: 'asc',
            sort_by: 'name',
            filter_by: 'subCategories.slug',
            city: null,
            tags: null,
            proximity: null,
            lat: null,
            lng: null,
            filter: null,
            keyword: null,
            page: 1,
            limit: 25,
        },

        activeBusiness: null,
        tags: [],
    };
  },
  mounted() {
      const params = new URLSearchParams(window.location.href.split('?')[1] ?? '');

      // Get the values of the 'tags[]' parameter as an array
      this.businessRequestParams.tags = params.getAll('tags[]');

      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
          this.checkCookies();
          this.locationEnable = false;
          this.businessLoad();
      }
      window.addEventListener('popstate', (event) => {
          this.checkAddressBar().then((resolve) => {
              this.loadCategories();
              this.loadCities();
              this.loadTags();
          });
      });
      window.onload = () => {
          this.checkIfMobile();
      };
      window.onresize = () => {
          this.checkIfMobile();
      };
      this.checkAddressBar().then((resolve) => {
          this.loadCategories();
          this.loadCities();
          this.loadTags();
      });

      this.showHideProximitySort('proximity');
  },
  methods: {
      businessLoad(){
          window.addEventListener('popstate', (event) => {
              this.checkAddressBar().then((resolve) => {
                  this.loadBusinesses();
              });
          });

          this.checkAddressBar().then((resolve) => {
              this.loadBusinesses(true);
          });
      },
      getCurrentLocation(){
          if (navigator.geolocation) {
              this.useCurrentLocation = true;
              navigator.geolocation.getCurrentPosition(this.renderPosition, this.customLocationError);
          } else {
              this.alertMessage("Your browser doesn't support the location service",'error')
          }
      },
      setCustomPostalCode() {
          this.businessRequestParams.lat = null;
          this.businessRequestParams.lng = null;
          this.businessRequestParams.proximity = null;
          this.businessRequestParams.sort_by = 'name';
          this.postalCode = '';
          // this.locationEnable = false;
          this.deleteCookies();
          this.$refs.cookie.setCookie('setPostalCode', true, 5000);
          this.loadBusinesses(true);
          this.isProximity = false;
      },
      async verifyPostalCode() {
          if (!!this.postalCode) {
              let geocoder = new window.google.maps.Geocoder();
              let zipCode = this.postalCode;
              let latitude = '';
              let longitude = '';
              let zeroResult = '';
              let city = '';
              let stateFullName = '';
              let stateShortName = '';
              try {
                  await geocoder.geocode({address: zipCode}, function (results, status) {
                      if (status == google.maps.GeocoderStatus.OK) {
                          latitude = results[0].geometry.location.lat();
                          longitude = results[0].geometry.location.lng();
                          for (let ac = 0; ac < results[0].address_components.length; ac++) {
                              let component = results[0].address_components[ac];
                              switch (component.types[0]) {
                                  case 'locality':
                                      city = component.long_name;
                                      break;
                                  case 'administrative_area_level_1':
                                      stateFullName = component.long_name;
                                      stateShortName = component.short_name;
                                      break;
                              }
                          }
                      } else {
                          zeroResult = true;
                      }
                  });
              } catch (e) {
                  zeroResult = true;
              }

              if (!!latitude && !!longitude) {
                  this.businessRequestParams.lat = latitude;
                  this.businessRequestParams.lng = longitude;
                  if(!!this.businessRequestParams.keyword){
                      this.businessRequestParams.proximity = 'unlimited';
                  }else {
                      if (!!stateFullName && stateFullName === 'Yukon') {
                          this.businessRequestParams.proximity = 'unlimited';
                      } else {
                          this.businessRequestParams.proximity = 'unlimited';
                      }
                  }
                  this.showHideProximitySort('proximity');
                  this.businessRequestParams.page = 1;
                  this.isProximity = true;

                  this.loadBusinesses(true);

                  this.$refs.cookie.setCookie('latitude', latitude, 5000);
                  this.$refs.cookie.setCookie('longitude', longitude, 5000);
                  this.$refs.cookie.setCookie('city', city, 5000);
                  this.$refs.cookie.setCookie('fullStateName', stateFullName, 5000);
                  this.$refs.cookie.setCookie('shortStateName', stateShortName, 5000);
                  this.$refs.cookie.setCookie('postalCode', this.postalCode, 5000);
                  this.$refs.cookie.setCookie('setPostalCode', true, 5000);

              } else if (!!zeroResult) {
                  this.alertMessage('Zero result against provided Postal Code', 'error');
              }
          } else {
              this.alertMessage('Please enter the Postal Code', 'error');
          }
      },
      alertMessage(message, type) {
          this.$toasted.show(message, {
              type: type,
              position: 'top-left',
              duration: 5000
          });
      },
      showPosition(position) {
          if(!this.checkCookieByName('setPostalCode')) {
              this.renderPosition(position);
          }
          if(!!this.checkCookieByName('postalCode')){
              this.isProximity = true;
              this.businessRequestParams.lat = this.checkCookieByName('latitude');
              this.businessRequestParams.lng = this.checkCookieByName('longitude');
              this.businessLoad();
          }

          if(!this.checkCookieByName('postalCode') && this.checkCookieByName('setPostalCode')){
              this.businessLoad();
          }
      },
      async renderPosition(position) {
          this.locationEnable = true;
          let getAddress = true;

          if (!!this.$refs.cookie.getCookie('latitude') && !!this.$refs.cookie.getCookie('longitude')) {
              let cookieLatitude = this.$refs.cookie.getCookie('latitude');
              let cookieLongitude = this.$refs.cookie.getCookie('longitude');
              if (cookieLatitude == position.coords.latitude && cookieLongitude == position.coords.longitude) {
                  getAddress = false;
              }
          }

          this.businessRequestParams.lat = position.coords.latitude;
          this.businessRequestParams.lng = position.coords.longitude;
          if (!this.businessRequestParams.proximity) {
              let stateName = this.$refs.cookie.getCookie('fullStateName');
              if(!!this.businessRequestParams.keyword){
                  this.businessRequestParams.proximity = 'unlimited';
              }else {
                  if (!!stateName && stateName === 'Yukon') {
                      this.businessRequestParams.proximity = 'unlimited';
                  } else {
                      this.businessRequestParams.proximity = 'unlimited';
                  }
              }
              this.showHideProximitySort('proximity');
          }
          if (this.useCurrentLocation) {
              this.businessRequestParams.page = 1;
          }
          this.useCurrentLocation = false;

          this.isProximity = true;
          await this.loadBusinesses(true);

          if (getAddress) {
              let latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
              // This is making the Geocode request
              let geocoder = new window.google.maps.Geocoder();

              await geocoder.geocode({'latLng': latlng}, (results, status) => {
                  if (status == google.maps.GeocoderStatus.OK) {
                      for (let ac = 0; ac < results[0].address_components.length; ac++) {
                          let component = results[0].address_components[ac];
                          switch (component.types[0]) {
                              case 'locality':
                                  this.$refs.cookie.setCookie('city', component.long_name, 5000);
                                  break;
                              case 'administrative_area_level_1':
                                  this.$refs.cookie.setCookie('fullStateName', component.long_name, 5000);
                                  this.$refs.cookie.setCookie('shortStateName', component.short_name, 5000);
                                  break;
                          }
                      }
                  }
              });
          }

          this.$refs.cookie.setCookie('latitude', this.businessRequestParams.lat, 5000);
          this.$refs.cookie.setCookie('longitude', this.businessRequestParams.lng, 5000);
          this.$refs.cookie.deleteCookie('postalCode');
          this.$refs.cookie.deleteCookie('setPostalCode');
          this.$refs.cookie.setCookie('currentLocation', true, 5000);
      },
      showError(error) {
          this.locationEnable = false;
          this.checkCookies();
          this.businessLoad();
      },
      customLocationError(error) {
          this.alertMessage('Your location is disabled please turn it on and reload the page','error')
      },
      deleteCookies() {
          this.$refs.cookie.deleteCookie('latitude');
          this.$refs.cookie.deleteCookie('longitude');
          this.$refs.cookie.deleteCookie('city');
          this.$refs.cookie.deleteCookie('fullStateName');
          this.$refs.cookie.deleteCookie('shortStateName');
          this.$refs.cookie.deleteCookie('postalCode');
          this.$refs.cookie.deleteCookie('currentLocation');
          this.$refs.cookie.deleteCookie('setPostalCode');
      },
      checkCookieByName(cname){
          let name = cname + "=";
          let decodedCookie = decodeURIComponent(document.cookie);
          let ca = decodedCookie.split(';');
          for(let i = 0; i <ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) == ' ') {
                  c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
              }
          }
          return "";
      },
      checkCookies() {
          if (!!this.$refs.cookie.getCookie('latitude') && !!this.$refs.cookie.getCookie('longitude')) {
              this.businessRequestParams.lat = this.$refs.cookie.getCookie('latitude');
              this.businessRequestParams.lng = this.$refs.cookie.getCookie('longitude');
              this.isProximity = true;
              this.updateAddressBar();
              if(!this.businessRequestParams.proximity) {
                  let stateName = this.$refs.cookie.getCookie('fullStateName');
                  if(!!this.businessRequestParams.keyword){
                      this.businessRequestParams.proximity = 'unlimited';
                  }else {
                      if (!!stateName && stateName === 'Yukon') {
                          this.businessRequestParams.proximity = 'unlimited';
                      } else {
                          this.businessRequestParams.proximity = 'unlimited';
                      }
                  }
                  this.showHideProximitySort('proximity');
              }
          } else {
              this.isProximity = false;
              this.deleteCookies();
          }
      },
      checkIfMobile() {
          if (window.innerWidth > 768) {
              this.isMobile = false;
          }
      },
      opened() {
          Vue.nextTick(() => {
              const active = this.$refs.select.$el.querySelector(
                  '.vs__dropdown-menu .vs__dropdown-option--selected',
              );
              if (active) {
                  active.scrollIntoView({
                      behavior: 'instant',
                      block: 'center',
                  });
              }
          });
      },
      scrollToActiveBusiness(business) {
          let activeBusinessRef = this.$refs[business.id];
          const elementPosition = activeBusinessRef[0].$el.getBoundingClientRect()
              .top;
          let offsetPosition =
              elementPosition -
              (window.innerHeight - activeBusinessRef[0].$el.clientHeight) / 2;
          if (window.scrollY > 0) {
              // This only works when scrolled some distance from the top
              activeBusinessRef[0].$el.scrollIntoView({
                  behavior: 'auto',
                  block: 'center',
                  inline: 'center',
              });
          } else {
              // This only works when not scrolled any distance from the top
              window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth',
              });
          }
      },
      updateActiveBusiness(business) {
          if (business) {
              if (!this.isMobile) {
                  this.scrollToActiveBusiness(business);
              }
              this.activeBusiness = business.id;
          } else {
              this.activeBusiness = null;
          }
      },
      requestCategories() {
          let data = {
              params: this.categoryRequestParams,
          };
          const request = axios.get(this.apiRoutes.categories, data);
          return request;
      },
      requestCities() {
          let data = {
              params: this.businessRequestParams,
          };
          const request = axios.get(this.apiRoutes.cities, data);
          return request;
      },
      loadCities() {
          this.requestCities()
              .then((response) => {
                  this.cityOptions = response.data;
              })
              .catch((error) => {
                  let response = error.response;
                  this.loading = false;
                  console.log(response);
              });
      },
      requestTags() {
          let data = {
              params: this.businessRequestParams,
          };
          return axios.get(this.apiRoutes.tags, data);
      },
      loadTags() {
          this.requestTags()
              .then((response) => {
                  this.tags = response.data;
              })
              .catch((error) => {
                  let response = error.response;
                  this.loading = false;
                  console.log(response);
              });
      },
      loadCategories() {
          this.requestCategories()
              .then((response) => {
                  const categories = response.data.data;
                  const processedCategories = categories
                      .map((category) => {
                          // category.disabled = true;
                          return [category, ...category.children];
                      })
                      .flat()
                      .filter((category) =>
                          category.parent_id ? category.number_of_businesses > 0 : true,
                      )
                      .map((category) => {
                          if (category.parent_id) {
                              category.name = `${category.name}`
                              category.bgOrange = false
                          }
                          else {
                              category.name = `${category.name}`
                              category.bgOrange = true
                          }

                          category.option = category;
                          return category;
                      });
                  this.categories = processedCategories;
                  this.loading = false;
              })
              .catch((error) => {
                  let response = error.response;
                  this.loading = false;
                  console.log(response);
              });
      },
      requestBusinesses() {
          let data = {
              params: this.businessRequestParams,
          };
          const request = axios.get(this.apiRoutes.businesses, data);
          return request;
      },
      async loadBusinesses(updateAddressBar = false) {
          if (updateAddressBar) await this.updateAddressBar();
          await this.requestBusinesses()
              .then((response) => {
                  this.businesses = response.data.data;
                  this.pagination.page = response.data.meta.current_page;
                  this.pagination.from = response.data.meta.from;
                  this.pagination.to = response.data.meta.to;
                  this.pagination.resultCount = response.data.meta.total;
                  this.pagination.pageCount = response.data.meta.last_page;
                  if (updateAddressBar) this.updateAddressBar();
                  this.$nextTick(() => {
                      this.loading = false;
                  });
              })
              .catch((error) => {
                  let response = error.response;
                  this.loading = false;
                  console.log(response);
              });
      },
      handleKeywordRemove() {
          this.businessRequestParams.keyword = null;
          this.loadBusinesses(true);
      },
      handleFilterChange(type = '') {
          if(type === 'city'){
              this.businessRequestParams.proximity = 'unlimited';
              this.businessRequestParams.keyword = null;
          }
          this.showHideProximitySort(type);
          this.businessRequestParams.page = 1;
          this.loadBusinesses(true);
      },
      handleTagChange(tags) {
          this.businessRequestParams.tags= tags;
          this.loadBusinesses(true);
      },
      showHideProximitySort(type) {
          if (type === 'proximity' && !!this.businessRequestParams.proximity
              && this.sortOptions[0].name !== "Proximity") {
              this.sortOptions.unshift({value: 'proximity.ASC', name: 'Proximity'});
          } else if (type === 'proximity' && this.businessRequestParams.proximity === null
              && this.sortOptions[0].name === "Proximity") {
              this.sortOptions.shift();
              this.sortSettings = null;
              this.businessRequestParams.order_by = 'ASC';
              this.businessRequestParams.sort_by = 'name';
          }
      },
      handleSortChange() {
          const sortSettingsArray = this.sortSettings.split('.');
          this.businessRequestParams.sort_by = sortSettingsArray[0];
          this.businessRequestParams.order_by = sortSettingsArray[1];
          this.loadBusinesses(true);
      },
      updatePagination(prev, next, page = null) {
          if (prev) Number((this.businessRequestParams.page -= 1));
          if (next) Number((this.businessRequestParams.page += 1));
          if (page) Number((this.businessRequestParams.page = page));
          const top = this.$refs.top;
          top.scrollIntoView(/*{ behavior: 'smooth' }*/);
          top.focus();
          this.loadBusinesses(true);
      },
      checkAddressBar() {
          const url = new URL(window.location.href);
          if (url.search) {
              const parameters = url.search.replace('?', '').split('&');
              parameters.forEach((parameter) => {
                  let name = parameter.split('=')[0];
                  let value = decodeURIComponent(
                      parameter.split('=')[1].replace('+', ' '),
                  );
                  if (value)
                      this.businessRequestParams[name] = value !== 'null' ? value : null;
              });
          }
          if (url.pathname.includes('category/')) {
              let category = url.pathname.split('category/')[1].replace('/', '');
              this.businessRequestParams.filter = category;
          }
          return new Promise((resolve, reject) => {
              resolve();
          });
      },
      updateAddressBar() {
          const pageUrl = this.pageUrl.endsWith('/')
              ? this.pageUrl
              : `${this.pageUrl}/`;
          let newUrl = new URL(pageUrl);
          if (this.businessRequestParams.filter) {
              newUrl.pathname = `/businesses/category/${this.businessRequestParams.filter}/`;
          } else {
              newUrl.pathname = `/businesses/`;
          }
          newUrl.search = `?order_by=${this.businessRequestParams.order_by}&sort_by=${this.businessRequestParams.sort_by}`;
          newUrl.search += `&page=${this.businessRequestParams.page}`;
          if (this.businessRequestParams.keyword)
              newUrl.search += `&keyword=${this.businessRequestParams.keyword}`;
          if (this.businessRequestParams.city)
              newUrl.search += `&city=${this.businessRequestParams.city}`;
          if (this.businessRequestParams.tags)
              this.businessRequestParams.tags.forEach((tag) => {
                  newUrl.search += `&tags[]=${tag}`;
              })
          if (this.businessRequestParams.proximity && !!this.businessRequestParams.proximity)
              newUrl.search += `&proximity=${this.businessRequestParams.proximity}`;
          if (this.businessRequestParams.lat)
              newUrl.search += `&lat=${this.businessRequestParams.lat}`;
          if (this.businessRequestParams.lng)
              newUrl.search += `&lng=${this.businessRequestParams.lng}`;
          history.pushState(null, null, newUrl);
      },
      getOptionClass(option) {
          if (option.bgOrange) {
              return 'bg-orange';
          }
          return '';
      },
  },
};
</script>
<style>
    .select2-container--default {
        width: 100% !important;
    }
    .select2-results__option {
        padding-right: 20px;
        vertical-align: middle;
    }
    .select2-results__option:before {
        content: "";
        display: inline-block;
        position: relative;
        height: 20px;
        width: 20px;
        border: 2px solid #e9e9e9;
        border-radius: 2px;
        background-color: #fff;
        margin-right: 20px;
        vertical-align: middle;
    }
    .select2-results__option[aria-selected="true"]:before, .select2-results__option--selected:before {
        font-family: fontAwesome;
        content: "\f00c";
        color: #fff;
        background-color: #f77750;
        border: 0;
        display: inline-block;
        padding-left: 3px;
        font-size: 14px;
        line-height: 1;
        vertical-align: middle;
        padding-top: 3px;
    }
    .select2-container--default .select2-selection--multiple {
        border-radius: unset !important;
        border: 1px solid !important;
        border-top: unset !important;
        padding-bottom: 0 !important;
    }
    .select2-search__field {
        padding-left: 7px !important;
        font-size: 16px !important;
        font-weight: 600 !important;
    }
    .select2-search__field::placeholder {
        color: #231f20 !important;
        font-size: 14px !important;
        font-weight: lighter !important;
        font-family: inherit !important;
    }
    .select2-container--default .select2-results__option[aria-selected="true"] {
        background-color: #fff;
    }
    .select2-container--default
    .select2-results__option--highlighted[aria-selected] {
        background-color: #eaeaeb;
        color: #272727;
    }
    .select2-container--default .select2-selection--multiple {
        margin-bottom: 10px;
    }
    .select2-container--open .select2-dropdown--below {
        border-radius: 6px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    }
    .select2-selection .select2-selection--multiple:after {
        content: "hhghgh";
    }
    /* select with icons badges single*/
    .select-icon .select2-selection__placeholder .badge {
        display: none;
    }
    .select-icon .placeholder {
        display: none;
    }
    .select-icon .select2-results__option:before,
    .select-icon .select2-results__option[aria-selected="true"]:before {
        display: none !important;
        /* content: "" !important; */
    }
    .select-icon .select2-search--dropdown {
        display: none;
    }
    .select2-selection__rendered .select2-selection__choice{
        color: white !important;
        font-size: 14px !important;
        background-color: #f37121 !important;
    }
    .select2-selection__choice {
        color: #fff !important;
        display: inline-block !important;
        line-height: 1 !important;
        margin-bottom: 5px !important;
        margin-right: 10px !important;
        max-width: 100% !important;
        position: relative !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        background: rgb(65, 184, 131) !important;
        border-radius: 5px !important;
        overflow: hidden !important;
        padding: 4px 0 2px 10px !important;
    }
    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover, .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:focus {
        background-color: #f37121 !important;
        color: #fff !important;
        outline: none !important;
    }
    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
        color: #fff !important;
        position: absolute !important;
        left: calc(100%/1.13) !important;
        /*width: 25% !important;*/
        padding-left: 5px !important;
        height: 100% !important;
        padding-right: 5px;
        top: 0 !important;
        padding-top: 3px !important;
    }
    .select2-selection__choice__remove span:hover {
        color: #fff !important;
    }
    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover, .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:focus {
        background: #e15d0d !important;
    }
    .select2-selection__choice__remove {
        border: unset !important;
    }
    .select2-selection__choice__remove span {
        float: right;
    }
    .select2-container--default .select2-selection--multiple .select2-selection__choice {
        border: none;
        width: 20% !important;
        margin-top: 4px !important;
    }
    .select2-dropdown {
        display: block !important;
        box-sizing: border-box !important;
        position: absolute !important;
        top: calc(100% - 1px) !important;
        left: 0 !important;
        z-index: 1000 !important;
        padding: 5px 0 !important;
        margin: 0 !important;
        overflow-y: auto !important;
        box-shadow: 0 3px 6px 0 rgba(0,0,0,.15) !important;
        border: 1px solid rgba(60,60,60,.26) !important;
        border-top-style: none !important;
        border-radius: 0 0 4px 4px !important;
        text-align: left !important;
        list-style: none !important;
        background: #fff !important;
    }
    .select2-container--default .select2-results__option--highlighted[aria-selected] {
        background-color: #1f2b7b !important;
        color: white !important;
    }
    .select2-container--default .select2-selection--multiple .select2-selection__choice__display {
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-top: 2px !important;
    }
    .select2-container--default .select2-search--inline .select2-search__field {
        margin-top: 3px !important;
    }

</style>
